module.exports = __webpack_public_path__ + "static/img/fz_fz_tb.acc65ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_fz_tb.png
// module id = GAj7
// module chunks = 0